export const columnOptions: Array<{
  value: string;
  label: string;
}> = [
  { label: 'Id', value: 'ID' },
  { label: 'Cliente', value: 'CLIENTE' },
  { label: 'Fazenda', value: 'FAZENDA' },
  { label: 'NF', value: 'NF' },
  { label: 'Código', value: 'CODIGO' },
  { label: 'Descrição', value: 'DESCRICAO' },
  { label: 'Quantidade', value: 'QTD' },
  { label: 'Entrada', value: 'ENTRADA' },
  { label: 'Dias armazenado', value: 'DIAS ARMAZENADO' },
  { label: 'Vencimento', value: 'VENCIMENTO' },
  { label: 'Lote', value: 'LOTE' },
  { label: 'Unidade', value: 'UNIDADE' },
  { label: 'Fabricação', value: 'FABRICACAO' },
  { label: 'Valor unitário', value: 'VALOR UNIT' },
  { label: 'Valor total', value: 'VALOR TOTAL' },
];